import { /*createWebHistory,*/createWebHashHistory, createRouter } from "vue-router";
import articleView from '@/components/articleView';
import awardView from '@/components/awardView';
import notFound from '@/components/notFound';

const routes = [
  {
    path: '/project/:award',
    name: 'award',
    component: awardView,
    // meta: { title: :article },
  },
  {
    path: '/article/:article',
    name: 'article',
    component: articleView,
    // meta: { title: :article },
  },
  {
    path: '/404',
    name: '404',
    component: notFound,
  },
  {
    path: '/:catchAll(.*)',
    name: 'notfound',
    component: notFound,
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;